import { createContext } from 'react';

/**
 * @type {import("react").Context<import("../types/store").QuestionLibraryZustandStore>}
 */
export const QuestionLibraryStoreContext = createContext(null);
